var $ = require('jQuery');
var Audio = require('../../lib/audio.js');
var Cards = require('../../lib/cards.js');
var tectoastr = require('tectoastr');
var VideoPlayer = require('../../lib/video-player.js');
var VideoModal = require('../../lib/video-modal.js');
var VideoThumbnails = require('../../lib/video-thumbnails.js');

module.exports = function()
{
    /**
     * Cards
     */
    var cards = new Cards;
    cards.setup('ul.cards', 'li', 'fitRows');

    /**
     * Audio
     */
    var audio = new Audio;
    audio.setup('jp-jplayer');

    /**
     * Video
     */
    var videoPlayer = new VideoPlayer;
    var videoModal = new VideoModal;
    var videoThumbnails = new VideoThumbnails;

    videoPlayer.setup('video-js-standalone');
    videoModal.setup('play-video');
    videoThumbnails.setup('preview-container.video');

    /**
     * Decide (pass/unsure/fail) buttons
     */
    var buttons = $('.decide-button, .undecide-button');
    var decideButtons = $('.decide-button');
    var undecideButton = $('.undecide-button');

    $(buttons).on('click', function () {
        var button = $(this);
        var decision = button.data('decision');

        // Check if already deciding
        if (button.hasClass('deciding')) {
            return;
        }

        button.addClass('deciding');

        // Send new decision to server
        $.ajax({
            'type': 'POST',
            'url': button.data('url'),
            'data': { 'decision' : decision },
            'dataType': 'json'

        }).done(function(response) {
            // Update button
            buttons.removeClass('deciding pass fail unsure')
            button.addClass(decision);

            // Show/hide Undecide Button
            undecideButton.toggleClass('hidden', !decision);

        }).fail(function(response) {
            // Throw error
            tectoastr.response(response.responseJSON, response.responseJSON.message || button.data('failed'));

            // Toggle button back
            button.removeClass('deciding');
        });
    });
};
